<div class="side-bar">
  <!-- Sticky Header Section (Only Back Button and Route Name) -->
  <div class="sticky-header">
    <div class="child-1 d-flex align-center just-space">
      <div class="d-flex align-center gap-16">
        <div>
          <img src="{{imgSrc}}assets/icons/left-arrow.svg" 
               style="cursor: pointer;" 
               (click)="onBackClick()"
               alt="Back">
        </div>
        <div class="d-flex flex-dir-col gap-4 route-name-cell">
          <span class="h5 route-name">{{routeName}}</span>
          <span class="route-meta-info" *ngIf="selectedDate && selectedShift">
            {{selectedDate}} • Shift {{selectedShift}}
          </span>
        </div>
      </div>
    </div>
  </div>

  <!-- Scrollable Content -->
  <div class="scrollable-content">
    <!-- Multi-Route View (works for single route too) -->
    <ng-container *ngIf="multiRouteData.length > 0">
      <div class="multi-route-container">
        <div *ngFor="let route of multiRouteData" class="route-card-wrapper">
          <!-- Collapsible Route Card -->
          <div class="route-card">
            <!-- Route Header (Always Visible) -->
            <div class="route-header" (click)="toggleRouteExpansion(route)">
              <div class="route-header-left">
                <span class="route-index">{{route.index}}</span>
                <div class="route-info">
                  <span class="route-path">{{route.startLocation}} → {{route.endLocation}}</span>
                  <span class="route-meta">{{route.vehicles?.length || 0}} vehicles • {{route.direction}}</span>
                </div>
              </div>
              <div class="route-header-right">
                <img 
                  [src]="route.isExpanded ? imgSrc + 'assets/route-replay/down-arrow.svg' : imgSrc + 'assets/route-replay/right-arrow.svg'" 
                  alt="toggle"
                  class="toggle-icon"
                />
              </div>
            </div>

            <!-- Expandable Route Content -->
            <div class="route-content" *ngIf="route.isExpanded">
              <!-- Route Details -->
              <div class="child-3 d-flex flex-dir-col">
                <app-route-details
                  [routeData]="route"
                  [routeName]="route.startLocation + ' → ' + route.endLocation"
                ></app-route-details>
              </div>

              <!-- Vehicles List -->
              <div class="child-5 d-flex flex-dir-col just-space">
                <app-vehicles-list
                  [vehicles]="route.vehicles || []"
                  (vehicleSelectionChange)="onMultiRouteVehicleSelectionChange(route.index! - 1, $event)"
                ></app-vehicles-list>
              </div>

              <!-- Stops Timeline -->
              <div class="child-4 d-flex flex-dir-col">
                <app-stops-timeline
                  [stops]="route.stops || []"
                ></app-stops-timeline>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
